// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"r6-z"};